var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "relative",
    class: _vm.legendHovered && 'cursor-pointer'
  }, [_c('canvas', {
    attrs: {
      "id": _vm.idChart,
      "height": _vm.c_height
    }
  })]), _vm._v(" "), _vm.tooSmall ? _c('div', {
    staticClass: "xl:ml-5 mt-5"
  }, _vm._l(_vm.labels, function (label, n) {
    return _c('p', {
      key: n,
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n      " + _vm._s(n + ' ' + label) + "\n    ")]);
  }), 0) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }